module.exports = "<p>\n  agreement-app-form works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/recovery/agreements-app/agreements-approval/agreement-app-form/agreement-app-form.component.html
// module id = ./src/app/recovery/agreements-app/agreements-approval/agreement-app-form/agreement-app-form.component.html
// module chunks = main